import { defineComponent } from 'vue'
import { intlNumberFormat } from '@/utils/money/amountFormat'

/*
* AG Grid Methods here
*/
export default defineComponent({
  methods: {
    // --- v31-safe shared grid helpers (centralized here; see docs/vue3-migration/UI-DIFF-VS-CPA.md batch C) ---

    // ag-grid v31 removed the internal `gridPanel`; the old `params.api.gridPanel.bodyHeight` guard threw
    // "Cannot read properties of undefined (reading 'bodyHeight')" and aborted the fit. Gate on the public api.
    safeSizeColumnsToFit (params) {
      const api = (params && params.api) || this.gridApi
      if (api && typeof api.sizeColumnsToFit === 'function') api.sizeColumnsToFit()
    },

    // v31: setRowData() was removed — set rows through the grid option, and clear the No-Rows overlay once
    // data arrives so a refetch (e.g. after posting a payment) can't leave the grid pinned on "No rows to show".
    setGridRows (rows) {
      if (!this.gridApi || typeof this.gridApi.setGridOption !== 'function') return
      this.gridApi.setGridOption('rowData', rows || [])
      if (rows && rows.length && typeof this.gridApi.hideOverlay === 'function') this.gridApi.hideOverlay()
    },

    // v31: setColumnDefs() is deprecated (removed v32) and the `setColumnDefs([])` reset drops column
    // width/state — set the defs through the grid option in a single call.
    setGridColumns (defs) {
      if (!this.gridApi || typeof this.gridApi.setGridOption !== 'function') return
      this.gridApi.setGridOption('columnDefs', defs || [])
    },

    pinSummaryTotalRow (gridApi) {
      /*
      return
      */
      const rootNode = (gridApi.getDisplayedRowAtIndex(0) || {}).parent
      if (rootNode && rootNode.aggData) {
        let current = rootNode.aggData
        current.transNumber = 'Total'
        gridApi.setPinnedBottomRowData([current])
      }
    },

    pinTotalRow (gridApi) {
      const rootNode = (gridApi.getDisplayedRowAtIndex(0) || {}).parent
      if (!this.originalTotals) {
        this.originalTotals = Object.assign({}, rootNode.aggData)
        this.originalTotals.accountName = 'Starting Total'
      }

      if (rootNode && rootNode.aggData) {
        const original = this.originalTotals
        let current = rootNode.aggData
        current.accountName = 'Current Total'
        const changed = {
          accountName: 'Changes This Session',
          costThisPeriod: current.costThisPeriod - original.costThisPeriod,
          costToDate: current.costToDate - original.costToDate,
          committedCost: current.committedCost - original.committedCost,
          baseCost: current.baseCost - original.baseCost,
          amount: current.amount - original.amount,
          etc: current.etc - original.etc,
          efc: current.efc - original.efc,
          overages: current.overages - original.overages,
          adjustedBudget: current.adjustedBudget - original.adjustedBudget,
          variance: current.variance - original.variance,
          varianceThisPeriod: current.varianceThisPeriod - original.varianceThisPerid
        }

        gridApi.setPinnedBottomRowData([original, changed, current])
      }
    },

    /*
    getSelectedRows () {
      const selectedNodes = this.gridApi.getSelectedNodes()
      const selectedData = selectedNodes.map((node) => node.data)
    },
    */

    // Redraw rows, useful to show changes and other styles
    redrawCurrentRow (rowNode) {
      if (!rowNode) {
        const cell = this.gridApi.getFocusedCell()
        rowNode = this.gridApi.getDisplayedRowAtIndex(cell.rowIndex)
      }
      if (!rowNode) return
      this.gridApi.redrawRows({ rowNodes: [rowNode] })
    },

    changeGrouping (expand = true) {
      if (this.displayOptions.groupingLevel < 0) this.displayOptions.groupingLevel = 0

      this.gridApi.forEachNode((node) => {
        if (expand === true) {
          node.setExpanded(true)
          this.displayOptions.groupingLevel++
        } else if (expand === false) {
          node.setExpanded(false)
          this.displayOptions.groupingLevel--
          if (node.level < this.displayOptions.groupingLevel - 1) {
            node.setExpanded(true)
          }
        }
      })
    },

    expandAll () {
      this.gridApi.expandAll()
    },

    collapseAll () {
      this.gridApi.collapseAll()
    },

    // Test function
    log (value) {
      console.log(value)
    },

    intlNumberFormatter (number, locale, options) {
      // CP0.3: delegates to the extracted pure formatter (single source of truth, under characterization test).
      return intlNumberFormat(number, locale, options, this.displayOptions)
    },

    // Send focus back to next cell
    setCellFocus (cell) {
      if (!cell) cell = this.gridApi.getFocusedCell()
      if (cell) this.gridApi.setFocusedCell(cell.rowIndex, cell.column)
    },

    getContextMenuItems (params) {
      const account = params.node.data && !params.node.group ? params.node.data.accountName : params.value
      const normal = [
        {
          name: 'Drill Down on ' + account,
          action: () => {
            this.drillDown()
          }
        }
      ]

      const group = [
        {
          name: 'No available actions',
          disabled: true
        }
      ]

      return params.node.group ? group : normal
    }
  }
})
